import { TableProps } from 'antd/es/table';

import { Status } from '@Components/Base';

export const mapColumns: TableProps['columns'] = [
  {
    title: 'REQUEST NO.',
    dataIndex: 'requestNo',
    key: 'reqNo',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'REQUEST DATE',
    dataIndex: 'requestDate',
    key: 'reqDate',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'REQUEST TYPE',
    dataIndex: 'requestType',
    key: 'requestTypeId',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'REQUEST DESCRIPTION',
    dataIndex: 'requestDescription',
    key: 'headerDesc',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'COST CENTER TYPE',
    dataIndex: 'costCenterType',
    key: 'ccTypeId',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'COST CENTER',
    dataIndex: 'costCenter',
    key: 'ccId',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'CREATED ON',
    dataIndex: 'createdOn',
    key: 'createdOn',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'APPROVER NAME',
    dataIndex: 'approverName',
    key: 'approverName',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'STATUS',
    dataIndex: 'status',
    key: 'statusId', // todo specify
    sorter: true,
    render: (text) => <Status text={text} />,
  },
];
